<template>
  <v-card
    class="mx-auto"
    max-width="400"
    raised
  >
  <router-link :to="'/blog/post/'+post.uid">
    <v-img
      class="white--text align-end minheight160@600"
      width="100%"
      :src="post.media"
    />
  </router-link>

    <v-card-title><router-link class="tdn fw400" :to="'/blog/post/'+post.uid"><h3 class="c-darkgray wbn">{{post.title}}</h3></router-link></v-card-title>

    <v-card-subtitle class="pb-0">
      <div class="mb5 c-gray fz12">{{post.date | fixDate}}</div>
        <router-link
          v-for="slug in post.categories"
          :key="slug.id"
          class="fOswald tdn curp" :to="'/blog/'+slug.slug"
        >
          <v-chip class="mb10 ma-1 curp" color="orange" small>{{slug.slug | capitalize}}</v-chip>
        </router-link>
      </v-card-subtitle>

    <v-card-text class="text--primary">
      <div>{{post.desc}}</div>
    </v-card-text>

    <!-- <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-heart</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon>mdi-bookmark</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<style lang="scss" scoped>
.wbn {
  word-break: normal;
}
.minheight160\@600 {
  @media all and (max-width: 600px) {
    min-height: 160px;
  }
}
</style>

<script>
import moment from 'moment';
  export default {

    data() {
      return {

      }
    },
    props: {
      post: {type: Object},
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      fixDate: function (value) {
        let date;
        let f = 'MMMM Do, YYYY';
        date = moment(value).format(f);
        return date
      }
    },
    methods: {

    }
  }
</script>